import { h } from "@stencil/core";

export const ErrorFlag = () => (
    <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g transform="translate(6.000000, 6.000000)">
                <polygon
                    fill="#CC292D"
                    fill-rule="nonzero"
                    points="25.498125 0 10.60425 0.01125 0.04275 10.589625 0 25.59375 10.501875 35.99775 24.96825 36 35.917875 25.268625 36 10.69425"
                ></polygon>
                <polygon
                    fill="#FFFFFF"
                    points="24.315 16 11.507 32.145 16.233 20 11 20 18.164 6 24.781 6 18.531 16"
                ></polygon>
            </g>
        </g>
    </svg>
);
